import { alpha } from '@mui/material/styles'

// Shared table style props to keep table bodies transparent and headers opaque.
export const createTableStyles = (theme) => ({
  muiTablePaperProps: ({ table }) => {
    const backgroundColor = table.getState().isFullScreen
      ? theme.palette.mode === 'dark' ? '#303030' : '#f4f4f6'
      : 'transparent'

    return {
      sx: {
        border: 'none',
        borderRadius: 0,
        boxShadow: 'none',
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        minHeight: 0,
        margin: 0,
        padding: 0,
        backgroundColor,
        '&.MuiPaper-root': {
          backgroundColor: `${backgroundColor} !important`,
          border: 'none',
          borderRadius: 0,
          boxShadow: 'none',
        },
      },
      elevation: 0,
    }
  },
  muiTableContainerProps: {
    sx: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'auto',
      maxHeight: '100%',
      minHeight: 0,
      backgroundColor: 'transparent',
      width: '100%',
      margin: 0,
      padding: 0,
    },
  },
  muiTableProps: {
    sx: { backgroundColor: 'transparent' },
  },
  muiTableHeadProps: {
    sx: { backgroundColor: 'transparent' },
  },
  muiTableBodyProps: {
    sx: { backgroundColor: 'transparent' },
  },
  muiTableFooterProps: {
    sx: { backgroundColor: 'transparent' },
  },
  muiTopToolbarProps: {
    sx: { backgroundColor: 'transparent' },
  },
  muiBottomToolbarProps: {
    sx: { backgroundColor: 'transparent' },
  },
  muiTableHeadCellProps: {
    sx: {
      backgroundColor: theme.palette.table.head,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  muiTableFooterCellProps: {
    sx: { backgroundColor: theme.palette.table.head },
  },
  muiTableBodyCellProps: ({ row }) => ({
    sx: createSelectableTableCellSx(theme, { selected: row.getIsSelected() }),
  }),
  muiTableBodyRowProps: ({ row }) => {
    const backgroundColor = row.getIsSelected() ? theme.palette.action.selected : 'transparent'

    return {
      sx: {
        backgroundColor: `${backgroundColor} !important`,
        '&:hover': {
          backgroundColor: `${backgroundColor} !important`,
        },
      },
    }
  },
})

export const createSelectableTableRowSx = (theme, { current = false, selected = false } = {}) => {
  const backgroundColor = getSelectableTableRowBackground(theme, { current, selected })

  return {
    cursor: 'pointer',
    backgroundColor: `${backgroundColor} !important`,
    // MRT and individual column definitions may paint their own cell
    // backgrounds. Apply the same state colour to every cell so selection is
    // visible across the complete row.
    '& > td': {
      backgroundColor: `${backgroundColor} !important`,
    },
    '&:hover': {
      backgroundColor: `${backgroundColor} !important`,
      '& > td': {
        backgroundColor: `${backgroundColor} !important`,
      },
    }
  }
}

export const createSelectableTableCellSx = (theme, { current = false, selected = false } = {}) => ({
  backgroundColor: `${getSelectableTableRowBackground(theme, { current, selected })} !important`,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
})

export const getSelectableTableRowBackground = (theme, { current, selected }) => current
  ? alpha(theme.palette.primary.main, 0.2)
  : selected ? theme.palette.action.selected : 'transparent'
